/**
 * 聊天输入框的快捷提示词模板配置。
 * 前端用这里的 key、标题和内容生成模板按钮，后端也会记录所选模板方便统计。
 */
export type PromptTemplateKey =
  | "translate"
  | "summarize"
  | "write_code"
  | "polish"
  | "explain_code";

export type PromptTemplate = {
  key: PromptTemplateKey;
  label: string;
  description: string;
  content: string;
};

export const PROMPT_TEMPLATES: PromptTemplate[] = [
  {
    key: "translate",
    label: "翻译",
    description: "中英互译并保留语气",
    content: "请把下面内容翻译成自然、准确的中文或英文，并保留原文语气：\n\n",
  },
  {
    key: "summarize",
    label: "总结",
    description: "提炼重点和行动项",
    content: "请总结下面内容，输出核心观点、关键细节和可执行事项：\n\n",
  },
  {
    key: "write_code",
    label: "写代码",
    description: "按需求生成代码",
    content: "请根据下面需求编写代码，说明关键思路，并给出必要的类型定义和边界处理：\n\n",
  },
  {
    key: "polish",
    label: "润色",
    description: "优化表达和结构",
    content: "请润色下面内容，让表达更清晰、自然、有条理，同时保留原意：\n\n",
  },
  {
    key: "explain_code",
    label: "解释代码",
    description: "解释逻辑、流程和风险点",
    content: "请解释下面代码的作用、执行流程、关键细节和可能的风险点：\n\n```ts\n\n```",
  },
];
